import { FC, SyntheticEvent } from 'react';

import { Link } from '../InteractiveTypography';

type ParentCardLinkProps = {
  href: string;
  title: string;
  onClick?(event: SyntheticEvent<HTMLElement>): void;
  track(): void;
};

export const ParentCardLink: FC<ParentCardLinkProps> = props => {
  const { href, title, onClick, track } = props;

  return (
    <Link behaviour="hover_primary_to_primary_hover" href={href} track={track} onClick={onClick}>
      {title}
    </Link>
  );
};
